<template>
	<v-card :elevation="1" class="background-2 round-card" width="100%">
        <v-card-title class="pa-3 py-1">
            <v-col class="pa-0">
			    <p class="pl-2 pl-xl-3">Configurazione Campi {{ $trans(modelDef) }}</p>      
            </v-col>
            <v-col class="pa-0">
                <v-tabs right class="tabs-pill" v-model="tab" background-color="background-2">
                    <v-tab :key="1" class="secondary-tab">Form</v-tab>
                    <v-tab :key="2" class="secondary-tab">Tabella</v-tab>
                </v-tabs>        
            </v-col>
        </v-card-title>
		<v-divider></v-divider>
        <v-card-text class="py-0 pb-3" v-if="load">
            <v-subheader class="pl-1 pt-4">Deseleziona i campi da nascondere</v-subheader>
            <v-tabs-items v-model="tab" touchless dense>
                <v-tab-item :key="1">

                    <v-container fluid class="background-2 pt-0">
                        <v-row>
                            <v-col class="pa-0 pl-1" cols="12" sm="3" md="3" v-for="(field, f) in fieldsset.fields" :key="f">
                                <v-checkbox
                                    v-model="field_setting[field.key]"
                                    :label="$trans(field.label)"
                                    color="primary"
                                    hide-details
                                ></v-checkbox>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-tab-item>

                <v-tab-item :key="2">

                    <v-container fluid class="background-2 pt-0">
                        <v-row>
                            <v-col class="pa-0 pl-1" cols="12" sm="3" md="3" v-for="(field, f) in fieldDefs.fieldDefs" :key="f">
                                <v-checkbox
                                    v-model="fieldDefs_setting[field.value]"
                                    :label="$trans(field.text)"
                                    color="primary"
                                    hide-details
                                ></v-checkbox>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-tab-item>
            </v-tabs-items>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pr-4 pb-2">
            <v-btn text color="info" @click.native="selectAll(true)">Tutti</v-btn>
            <v-btn text color="info" @click.native="selectAll(false)">Nessuno</v-btn>
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click.native="saveSettings">Salva</v-btn>
        </v-card-actions>        
    </v-card>
</template>

<script>
	import Vue from 'vue' 

    export default {
        name: 'selector-fields',
        props: {
            modelDef: String
        },

        data() {
            return {
                tab: null,
                load: false,
                fieldsset: {},
                fieldDefs: {},
                field_setting: {},
                fieldDefs_setting: {},
            }
        },

        computed: {

        },

        methods: {
            saveSettings() {
                let data = {}

                data = {model: this.modelDef, field_setting: this.field_setting}
                this.axios.post('settings/', data).then(response => {
                    // get body data
                    this.$store.commit('setSnackbar', {timeout: 6000, text: 'Impostazioni salvate', value: true, color: 'success'})
                    this.$store.commit('SET_SETTINGS', response.data.settings)
                }, response => {
                    // error callback
                })                    
            
                data = {model: this.modelDef, fieldDefs_setting: this.fieldDefs_setting}
                this.axios.post('settings/', data).then(response => {
                    // get body data
                    this.$store.commit('setSnackbar', {timeout: 6000, text: 'Impostazioni salvate', value: true, color: 'success'})
                    this.$store.commit('SET_SETTINGS', response.data.settings)
                    localStorage.removeItem('crud_pagination_'+this.response.data.modelDefs)
                }, response => {
                    // error callback
                })

            },

            selectAll(value) {
                if(this.tab == 0) {
                    _.forEach(this.field_setting, (f, i) => {
                        Vue.set(this.field_setting, i, value)
                    })
                } else if(this.tab == 1) {
                    _.forEach(this.fieldDefs_setting, (f, i) => {
                        Vue.set(this.fieldDefs_setting, i, value)
                    })
                }
            },
        },

        mounted() {
            this.axios.post('settings/fields-model/', {model: this.modelDef}).then(response => {
                // get body data
                this.fieldsset = response.data.fields
                this.fieldDefs = response.data.fieldDefs
                this.field_setting = response.data.fields_values ? response.data.fields_values : {}
                if(!response.data.fields_values) {
                    _.forEach(this.fieldsset.fields, (field) => {
                        Vue.set(this.field_setting, field.key, true)
                    })
                }
                this.fieldDefs_setting = response.data.fieldDefs_values ? response.data.fieldDefs_values : {}
                if(!response.data.fieldDefs_values) {
                    _.forEach(this.fieldDefs.fieldDefs, (field) => {
                        Vue.set(this.fieldDefs_setting, field.value, true)
                    })
                }
                this.load = true
                this.$store.commit('endProgress')

            }, response => {
                // error callback
            })
        },
    }
</script>